import axios from 'src/api/Api';
import {
    GET_DASHBOARD_LIST_SUCCESS,
    GET_DASHBOARD_LIST_FAILURE,
} from '../actions';
import { put, call } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

const buildUrl = (baseSiteId, params = {}) => {
    const queryParams = new URLSearchParams(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
    );

    const qs = queryParams.toString();

    return qs
        ? `/occ/v2/${baseSiteId}/dashboard/list?${qs}`
        : `/occ/v2/${baseSiteId}/dashboard/list`;
};

export default function* getDashboardList(action) {
    const baseSiteId = localStorage.getItem('baseSiteId') || 'defaultSite';
    const requestParams = action?.payload || {};
    const url = buildUrl(baseSiteId, {
        pageLimit: 50,
        pageNum: 0,
        ...requestParams,
    });

    try {
        const { data: result } = yield call(axios.get, url);

        yield put({
            type: GET_DASHBOARD_LIST_SUCCESS,
            payload: result?.districtList || [],
            districtFilterList: result?.districtFilterList || [],
            defaultDate: result?.defaultDate || null,
            totalNoOfDistricts: result?.totalNoOfDistricts || 0,
        });
    } catch (error) {
        logUiErrorToBackend(error, { apiEndPoint: url });

        yield put({
            type: GET_DASHBOARD_LIST_FAILURE,
            payload: { error: errorHandler(error?.response?.status || '503') },
        });
    }
}
